<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div>
    <slot></slot>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
